// LILLA V — meny. All text och alla bilder redigeras här.
// price: null betyder att priset ännu inte är satt (visas som en tom prisplats).

export type MenuImage = {
  src: string
  alt: string
  zoom?: number
  focus?: string
}

export type MenuItem = {
  name: string
  ingredients: string
  price: string | null
}

export type MenuCategory = {
  id: string
  title: string
  tagline: string
  intro?: string
  items: MenuItem[]
  images: MenuImage[]
  columns: string
}

export const MENU_CATEGORIES: MenuCategory[] = [
  {
    id: 'signaturverk',
    title: 'LV Signaturverk',
    tagline: 'Det vi är kända för',
    intro:
      'Våra signaturverk finns i disken varje dag och går att förbeställa utöver mackorna.',
    columns: 'md:grid-cols-4',
    items: [
      {
        name: 'Basque Cheesecake',
        ingredients:
          'Bränd yta · krämig mitt · hel kaka eller bit',
        price: null,
      },
      {
        name: 'Pain au Chocolat',
        ingredients: 'Smörig jästdeg · mörk choklad · bakad på plats',
        price: null,
      },
      {
        name: 'Cookies',
        ingredients: 'Choklad eller matcha · vit choklad · frystorkade hallon',
        price: null,
      },
      {
        name: 'Brownie',
        ingredients: 'Mascarponefyllning · mango & passionsfrukt · timjan',
        price: null,
      },
    ],
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/3RYC93pccXN5XDyS56ph5C/IMG_0592.png',
        alt: 'Basque cheesecake med bränd yta och krämig mitt',
        zoom: 1.2,
        focus: 'center 60%',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/7fG35a1VbtM3NctqvUiKYf/35677327-8D71-4B0C-8305-E02C836CAB8C_2.png',
        alt: 'Pain au chocolat med smöriga lager',
        zoom: 1.5,
        focus: '35% 60%',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/7M6pwwh1qBWMmRLtT94dzD/IMG_8838.png',
        alt: 'Cookies i choklad och matcha med frystorkade hallon',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/fwrn8gquAUvT8w9W5BxGQe/IMG_3640.png',
        alt: 'Brownie med mascarponefyllning och mangocurd',
        zoom: 1.7,
        focus: 'center 60%',
      },
    ],
  },
  {
    id: 'mackor',
    title: 'Mackor',
    tagline: 'Surdeg, ost och några djärva kombinationer',
    intro:
      'Fyra mackor som roterar med säsongen. Alla går att förbeställa för avhämtning.',
    columns: 'md:grid-cols-4',
    items: [
      {
        name: 'Beet & Bleat',
        ingredients:
          'Chèvre · rödbeta · valnöt · grönkål · fänkål · honung · granatäpple · picklad rödkål',
        price: null,
      },
      {
        name: 'Fig & Pig',
        ingredients:
          'Taleggio · prosciutto · chèvrekräm · sallad · sockerärta & majs · fikon',
        price: null,
      },
      {
        name: 'Bee & Brie',
        ingredients:
          'Brie · salami · chèvrekräm · spenat · fänkål · salladslök · oliver · hot honey',
        price: null,
      },
      {
        name: 'Tuna Matata',
        ingredients:
          'Tonfiskröra · spenat · tomat · picklad silverlök · svartpeppar',
        price: null,
      },
    ],
    images: [
      { src: 'https://cdn.magicpatterns.com/uploads/27RGErwjRfq1sQK4Qk2X2B/4.png', alt: 'Beet & Bleat' },
      { src: 'https://cdn.magicpatterns.com/uploads/nPP3FAmZ6XFasAgSBgW3yM/6.png', alt: 'Fig & Pig' },
      { src: 'https://cdn.magicpatterns.com/uploads/u35Yd8CjWfK3R4kLB5XoSh/5.png', alt: 'Bee & Brie' },
      { src: 'https://cdn.magicpatterns.com/uploads/bp9CpVUnut7DYTyE5iNtEi/7.png', alt: 'Tuna Matata' },
    ],
  },
  {
    id: 'matverk',
    title: 'Matverk',
    tagline: 'Sallader och bowls att sitta ner med',
    columns: 'md:grid-cols-3',
    items: [
      {
        name: 'Goat Game',
        ingredients:
          'Grönkål · sallad · chèvre · rödbeta · valnöt · picklad rödkål · granatäpple · hot honey',
        price: null,
      },
      {
        name: 'Peas of Mind',
        ingredients:
          'Grönkål · sallad · chèvrekräm · sockerärta & majs · prosciutto · fikon',
        price: null,
      },
      {
        name: 'Tune In',
        ingredients:
          'Tonfiskröra · gröna ärter · kikärtor · fänkål · cornichons · syltlök · oliver',
        price: null,
      },
    ],
    images: [
      { src: 'https://cdn.magicpatterns.com/uploads/8PC4WAQvXYEnkZ9BWBhXQn/image.png', alt: 'Sallad med rödbetor, chèvre och valnötter' },
      { src: 'https://cdn.magicpatterns.com/uploads/kbZMKESV74Rt9BvFLVbVoL/IMG_2240.png', alt: 'Bowl med lax, rostad pumpa och fänkål' },
      { src: 'https://cdn.magicpatterns.com/uploads/4AapBqGR2haz4W3cxqukgc/IMG_1971.png', alt: 'Krämig risotto med chark och parmesan' },
      { src: 'https://cdn.magicpatterns.com/uploads/rizuaq8MvUCRbv477AZHpM/IMG_9479.png', alt: 'Pasta i tomatsås med stracciatella', zoom: 1.35, focus: 'center 55%' },
      { src: 'https://cdn.magicpatterns.com/uploads/epfkZvyfBvx37qFEBZ7d23/IMG_9342.png', alt: 'Avokadotoast på surdeg med ost och chili', zoom: 1.3, focus: 'center 58%' },
      { src: 'https://cdn.magicpatterns.com/uploads/jgdAuyYSJ9mjyfXE1yPDNt/IMG_9849.png', alt: 'Bowl med svart ris, grillad paprika och nudelsallad' },
    ],
  },
  {
    id: 'dryck',
    title: 'Dryck',
    tagline: 'Matcha, kaffe och kolsyrat',
    columns: 'md:grid-cols-4',
    items: [
      {
        name: 'Matcha Latte',
        ingredients:
          'Iskall matcha på Sproud ärtmjölk · naturell eller vanilj · jordgubb som tillval',
        price: null,
      },
      {
        name: 'Matcha Tonic',
        ingredients: 'Matcha · tonic',
        price: null,
      },
      {
        name: 'Matcha Honey Lemonade',
        ingredients: 'Kolsyrad matcha · Honey Lemon eller passionsfrukt',
        price: null,
      },
      {
        name: 'Espresso Tonic',
        ingredients:
          'Kallbryggd espresso · tonic · Honey Lemon eller passionsfrukt som tillval',
        price: null,
      },
      {
        name: 'Honey Lemonade',
        ingredients: 'Kolsyrad citron & honung',
        price: null,
      },
    ],
    images: [
      { src: 'https://cdn.magicpatterns.com/uploads/beYvedok5pNdeGes7XewjM/IMG_2815.png', alt: 'Alkoholfri soda med rödbeta och granatäpple', zoom: 1.25, focus: 'center 58%' },
      { src: 'https://cdn.magicpatterns.com/uploads/3h47bJv16bd6uTUJGFkHCw/IMG_2329_2.png', alt: 'Iskall bärdrink i rundat glas', zoom: 1.35, focus: 'center 55%' },
      { src: 'https://cdn.magicpatterns.com/uploads/8byk3Zig3Rv3KXtt2tuspu/IMG_2243_2.png', alt: 'Iskall matchalemonad i take away-glas', zoom: 1.6, focus: '38% 48%' },
      { src: 'https://cdn.magicpatterns.com/uploads/7qYZw2kcbf3JwxAqVgVeA2/IMG_3106.png', alt: 'Iskall citrusdrink med bubblor', zoom: 1.3, focus: 'center 52%' },
    ],
  },
  {
    id: 'bakverk',
    title: 'Bakverk',
    tagline: 'Ur ugnen, varje morgon',
    intro: 'Dagens bakverk roterar — kom in och se vad som står i disken.',
    columns: 'md:grid-cols-4',
    items: [],
    images: [
      { src: 'https://cdn.magicpatterns.com/uploads/2b4dT9UBEnq7okYXDWMGF8/IMG_8838.png', alt: 'Nybakade cookies — choklad och matcha med frystorkade hallon' },
      { src: 'https://cdn.magicpatterns.com/uploads/tM9asytZHAhGGkVRbrkg93/35677327-8D71-4B0C-8305-E02C836CAB8C_2.png', alt: 'Pain au chocolat med smöriga lager', zoom: 1.35, focus: '38% 58%' },
      { src: 'https://cdn.magicpatterns.com/uploads/jJFVLrBDPcXKtGMw8AS6ZT/FA3D39BA-B8AA-4347-9122-6FB0CBA5590E.png', alt: 'Saffransbulle med vaniljkräm', zoom: 1.3, focus: 'center 45%' },
      { src: 'https://cdn.magicpatterns.com/uploads/h6ni9jZvYhDA3jec31E9BZ/IMG_3625.png', alt: 'Pistagesnitt med hallonsylt', zoom: 1.7, focus: 'center 62%' },
      { src: 'https://cdn.magicpatterns.com/uploads/ixk8VVPRo9HjrY7Kb64QAh/IMG_3640.png', alt: 'Chokladbakelse med vaniljkräm och mangocurd', zoom: 1.7, focus: 'center 62%' },
      { src: 'https://cdn.magicpatterns.com/uploads/mgf91AeWYrRY9f7xxLBBP6/IMG_2875.png', alt: 'Tiramisu med kakaopulver', zoom: 1.45, focus: 'center 62%' },
      { src: 'https://cdn.magicpatterns.com/uploads/6vxw1PpmcWXhPYgnCPaLxW/IMG_9334.png', alt: 'Brownie med grädde och hallon', zoom: 1.75, focus: 'center 58%' },
      { src: 'https://cdn.magicpatterns.com/uploads/5QVovfF6uyFnLckQ8V89ej/IMG_9109_2.png', alt: 'Rostad ostmacka med sylt', zoom: 1.9, focus: 'center 68%' },
    ],
  },
  {
    id: 'ost-chark',
    title: 'Ost & Chark',
    tagline: 'Brickor att dela på',
    intro: 'Sätts ihop efter vad vi har inne — säg till om ni vill ha förslag.',
    columns: 'md:grid-cols-2',
    items: [],
    images: [
      { src: 'https://cdn.magicpatterns.com/uploads/vPokmV8RyEjX3s988BFrvX/IMG_1632.png', alt: 'Ostbricka med blåmögelost, hårdost, oliver och knäckebröd', zoom: 1.3, focus: 'center 62%' },
      { src: 'https://cdn.magicpatterns.com/uploads/wwmbRDKKiH3wyS45uXoQbV/IMG_1644.png', alt: 'Charkbricka med prosciutto och mortadella', zoom: 1.4, focus: 'center 75%' },
    ],
  },
]

export const VIN_TEASER_IMAGES: MenuImage[] = [
  { src: 'https://cdn.magicpatterns.com/uploads/kWL6LGzqSy6CouuAqr12J5/IMG_1628.png', alt: 'Vita viner och orangeviner på rad i baren' },
  { src: 'https://cdn.magicpatterns.com/uploads/87u9Y8wquofnDfgoBKW4Ut/IMG_1649.png', alt: 'Röda viner på rad i baren' },
]
